import castValueAsNumber from 'common/helpers/castNumberInput';
import handleError from 'common/helpers/handleError';

export default {
  data() {
    return {
      model: undefined,
    };
  },
  methods: {
    castValueAsNumber,
    async onChangeImage(field, fileData) {
      if (!fileData) {
        // eslint-disable-next-line
        this.$set(this.model, field, null);
        return;
      }
      try {
        const { data } = await this.$axios.post('files', { fileData });
        this.$set(this.model, field, data.data.url);
      } catch (error) {
        handleError(error);
      }
    },
  },
};
